import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Gmap from './Gmap';
import Select from 'react-select';
import Slider from '@mui/material/Slider';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import {
  itemConditionOptions,
  miscCategoryOptions,
  approximateAgeOptions,
  colorOptions,
  itemPickupDeliveryOptions,
  sellerTypeOptions
} from '../contants/data';
// ICONS
import { GrPowerReset } from 'react-icons/gr';
import { FaPlusCircle, FaMinusCircle } from 'react-icons/fa';

const Filters = ({ onFilter, data, stateCategory, filters }) => {
  const [thunks, setThunks] = useState(null);
  const [showAdvFilter, setShowAdvFilter] = useState(false);
  const { isFilter } = useSelector((state) => state[stateCategory]);
  const dispatch = useDispatch();

  // GEOLOCATE
  const { lat, lng, radius } = useSelector(
    (state) => state[stateCategory].filters.location
  );

  // NEW LAT,LNG
  const [newLat, setNewLat] = useState('');
  const [newLng, setNewLng] = useState('');

  // PRICE
  const { min: priceMin, max: priceMax } = useSelector(
    (state) => state[stateCategory].filters.price_range
  );
  const [priceVal, setPriceVal] = useState([priceMin, priceMax]);
  const handlePriceChange = (event, newValue) => {
    setPriceVal(newValue);
    dispatch(thunks?.changePrice({ min: newValue[0], max: newValue[1] }));
  };

  // CATEGORY
  const { miscCategory } = useSelector(
    (state) => state[stateCategory].filters
  );
  const [selectedMiscCategory, setSelectedMiscCategory] = useState([]);
  const handleMiscCategoryChange = (options) => {
    setSelectedMiscCategory(
      options ? options.map((option) => option.value) : []
    );
    dispatch(
      thunks?.changeMiscCategory(
        options ? options.map((option) => option.value) : []
      )
    );
  };

    // ITEM CONDITION
    const { itemCondition } = useSelector((state) => state[stateCategory].filters);
    const [selectedItemCondition, setSelectedItemCondition] = useState([]);
    const handleItemConditionChange = (options) => {
      setSelectedItemCondition(options ? options.map((option) => option.value) : []);
      dispatch(
        thunks?.changeItemCondition(
          options ? options.map((option) => option.value) : []
        )
      );
    };

  // APPROXIMATE AGE
    const { approximateAge } = useSelector((state) => state[stateCategory].filters);
    const [selectedApproximateAge, setSelectedApproximateAge] = useState([]);
    const handleApproximateAgeChange = (options) => {
      setSelectedApproximateAge(options ? options.map((option) => option.value) : []);
        dispatch(
          thunks?.changeApproximateAge(
            options ? options.map((option) => option.value) : []
          )
        );
  };

  // COLOR
  const { color } = useSelector((state) => state[stateCategory].filters);
  const [selectedColor, setSelectedColor] = useState([]);
  const handleColorChange = (options) => {
    setSelectedColor(options ? options.map((option) => option.value) : []);
      dispatch(
        thunks?.changeColor(
          options ? options.map((option) => option.value) : []
        )
      );
  }; 
  
  // ITEM PICKUP/DELIVERY
    const { itemPickupDelivery } = useSelector(
      (state) => state[stateCategory].filters
    );
    const [selectedItemPickupDelivery, setSelectedItemPickupDelivery] = useState([]);
    const handleItemPickupDeliveryChange = (options) => {
      setSelectedItemPickupDelivery(
        options ? options.map((option) => option.value) : []
      );
      dispatch(
        thunks?.changeItemPickupDelivery(
          options ? options.map((option) => option.value) : []
        )
      );
    };
  
  // SELLER TYPE
  const { sellerType } = useSelector((state) => state[stateCategory].filters);
  const [selectedSellerType, setSelectedSellerType] = useState([]);
  const handleSellerTypeChange = (options) => {
    setSelectedSellerType(options ? options.map((option) => option.value) : []);
      dispatch(
        thunks?.changeSellerType(
          options ? options.map((option) => option.value) : []
        )
      );
  };

  // PROPERTY FEATURES
  const { propertyFeatures } = useSelector(
    (state) => state[stateCategory].filters
  );
  const [selectedPropertyFeatures, setSelectedPropertyFeatures] = useState([]);
  const handlePropertyFeaturesChange = (options) => {
    setSelectedPropertyFeatures(
      options ? options.map((option) => option.value) : []
    );
    dispatch(
      thunks?.changePropertyFeatures(
        options ? options.map((option) => option.value) : []
      )
    );
  };


  useEffect(() => {
    const loadThunks = async () => {
      let importedThunks;
      if (stateCategory === 'misc') {
        importedThunks = await import('../store/slices/misc.slice');
      }
      setThunks(importedThunks);
    };

    loadThunks();
  }, [stateCategory]);

  if (!thunks) {
    return <div>Loading...</div>;
  }

  const handleSubmit = () => {
    let finalLat = '';
    let finalLng = '';
    if ((newLat != '') & (newLng != '')) {
      finalLat = newLat;
      finalLng = newLng;
      dispatch(thunks?.changeLocation({ lat: finalLat, lng: finalLng }));
    } else {
      finalLat = lat;
      finalLng = lng;
    }

    onFilter({
      finalLat,
      finalLng,
      radius,
      priceVal,
      propertyFeatures,
      miscCategory,
      itemCondition,
      approximateAge,
      color,
      itemPickupDelivery,
      sellerType
    });
    dispatch(thunks?.activateFilter(true));
    dispatch(thunks?.setSearchTerm(''));
    dispatch(thunks?.setSortBy('Closest to Me'));
    dispatch(thunks?.resetSortedData());
  };

  const updateLoc = (lat, lng) => {
    setNewLat(() => {
      return lat;
    });
    setNewLng(() => {
      return lng;
    });
  };

  const handleResetFilter = () => {
    window.location.reload();
  };

  return (
    <div className='sidebar hide-mobile'>
      <Gmap onChangeLoc={updateLoc} data={data} />
      {filters.includes('Price') && (
        <div className='form-control-wrap'>
          <label>Price</label>
          <Slider
            value={priceVal}
            onChange={handlePriceChange}
            valueLabelDisplay='auto'
            max={20000}
            step={10}
          />
          <div className='price-range-wrap'>
            <span>${priceVal[0].toLocaleString('en-US')} - </span>
            <span>${priceVal[1].toLocaleString('en-US')}</span>
          </div>
        </div>
      )}

      {filters.includes('Misc Category') && (
        <div className='form-control-wrap'>
          <label>Category</label>
          <Select
            isMulti
            options={miscCategoryOptions}
            onChange={handleMiscCategoryChange}
            value={miscCategoryOptions.filter((option) =>
              selectedMiscCategory.includes(option.value)
            )}
            className='border-0'
          />
        </div>
      )}

      {filters.includes('Item Condition') && (
        <div className='form-control-wrap'>
          <label>Item Condition</label>
          <Select
            isMulti
            options={itemConditionOptions}
            onChange={handleItemConditionChange}
            value={itemConditionOptions.filter((option) =>
              selectedItemCondition.includes(option.value)
            )}
            className='border-0'
          />
        </div>
      )}

      {filters.includes('Approximate Age') && (
        <div className='form-control-wrap'>
          <label>Approximate Age</label>
          <Select
            isMulti
            options={approximateAgeOptions}
            onChange={handleApproximateAgeChange}
            value={approximateAgeOptions.filter((option) =>
              selectedApproximateAge.includes(option.value)
            )}
            className='border-0'
          />
        </div>
      )}

      {filters.includes('Color') && (
        <div className='form-control-wrap'>
          <label>Color</label>
          <Select
            isMulti
            options={colorOptions}
            onChange={handleColorChange}
            value={colorOptions.filter((option) =>
              selectedColor.includes(option.value)
            )}
            className='border-0'
          />
        </div>
      )}

      {filters.includes('Item Pickup/Delivery') && (
        <div className='form-control-wrap'>
          <label>Item Pickup/Delivery</label>
          <Select
            isMulti
            options={itemPickupDeliveryOptions}
            onChange={handleItemPickupDeliveryChange}
            value={itemPickupDeliveryOptions.filter((option) =>
              selectedItemPickupDelivery.includes(option.value)
            )}
            className='border-0'
          />
        </div>
      )}

      {filters.includes('Seller Type') && (
        <div className='form-control-wrap'>
          <label>Seller Type</label>
          <Select
            isMulti
            options={sellerTypeOptions}
            onChange={handleSellerTypeChange}
            value={sellerTypeOptions.filter((option) =>
              selectedSellerType.includes(option.value)
            )}
            className='border-0'
          />
        </div>
      )}

      <button onClick={() => handleSubmit()} className='primary mb-10'>
        Filter
      </button>
      <button
        onClick={() => handleResetFilter()}
        className='reset'
        disabled={!isFilter}
      >
        Reset Filter
      </button>
    </div>
  );
};

export default Filters;
